module.exports = __webpack_public_path__ + "img/dc59b26.png";